module.exports = __webpack_public_path__ + "img/tabler-icon.c4acdfe2.svg";